//@ts-check

// External
import React, { Children, useEffect, useRef, useState } from "react"
//@ts-ignore
import _ from "lodash"
import { useTranslation } from "react-i18next"
// Internal
import StepsList from "../components/steps-list"
import AddStepButtons from "../components/add-step-buttons"
import StepViewEdit from "../components/step-view-edit.js"
import store from "../store"
import TextSwitch from "../components/text-switch"
import { isStoryValidated } from "../validations"
import Button from "../components/button"
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline"
// @ts-ignore
import { useParams } from "react-router-dom"
import { requestJSON } from "../utils/request-module"
import InputNumber from "src/components/input-number"
import { CircularProgress } from "@material-ui/core"
import { delay } from "../utils/react-utils"
import {
  ExpandIcon,
  OneColumnIcon,
  TwoColumnIcon,
  VerticallyCollapseIcon,
  VerticallyExpandIcon,
} from "src/components/icons-svg"
import Tooltip from "src/components/tooltip"
import AIfeedback from "src/components/ai-feedback"

// The backend may return the block number as a hex string (e.g. "0x16e360")
// or as a decimal number. The block-number input expects a decimal integer,
// so normalize here. Returns null when the value is missing/invalid so that
// the UI doesn't try to render `undefined` and the spinner can still clear.
function normalizeBlockNumber(value) {
  if (value === undefined || value === null || value === "") return null
  if (typeof value === "number" && Number.isFinite(value)) return value
  if (typeof value === "string") {
    const parsed = value.startsWith("0x")
      ? parseInt(value, 16)
      : parseInt(value, 10)
    return Number.isFinite(parsed) ? parsed : null
  }
  return null
}

export default function VisualBlockchain(props) {
  // console.log('VisualBlockchain rerender')
  // State and hooks
  const { t } = useTranslation()
  const [fetchingBlockNumber, setfetchingBlockNumber] = useState(false)
  store.useRerenderIfChange(() => [
    // store.steps,
    store.selectedStep,
    store.isDryRun,
    // store.results,
    store.network,
    store.isMainnet,
    store.blockNumber,
    store.isLoadingResults,
    store.selectedAddress(),
  ])

  // The legacy v1 route is `/simulation/:id`, so `useParams().id` works there.
  // The v2 route is `/v2/reports/:reviewId` and renders <OneSimulation> with
  // the simulation id as a prop — `useParams().id` is undefined in that case.
  // Accept the id as a prop and fall back to useParams() so both paths work
  // and we never end up calling `PUT /simulation/undefined`.
  var params = useParams()
  var id = props.simulationId || params.id

  const onIsMainnetChange = async (value) => {
    try {
      setfetchingBlockNumber(true)
      store.isMainnet = value
      if (value) {
        let lastblock = await store.getLatestBlock()
        const blockNum = normalizeBlockNumber(lastblock && lastblock.number)
        onBlockNumberChange(blockNum)
      } else {
        onBlockNumberChange(null)
      }
      store.updateSimulationMaindataProperty("isMainnet", store.isMainnet, id)
      store.updateSimulationMaindataProperty(
        "blockNumber",
        store.blockNumber,
        id,
      )
      if (id) {
        await store.updateOneSimulation(id, {
          isMainnet: store.isMainnet,
          blockNumber: store.blockNumber,
        })
      }
    } catch (err) {
      console.log("Some error has occured while updating block number ", err)
    } finally {
      setfetchingBlockNumber(false)
    }
  }

  const onBlockNumberChange = (value) => {
    store.blockNumber = value
    store.updateStore()
  }

  const updateBlockNumber = async (value) => {
    try {
      store.updateSimulationMaindataProperty("blockNumber", value, id)
      if (id) {
        await store.updateOneSimulation(id, { blockNumber: value })
      }
    } catch (err) {
      console.log("Some error has occured while updating block number ", err)
    }
  }

  const getLatestBlockNumber = async () => {
    try {
      store.latestBlock = null
      store.updateStore()
      setfetchingBlockNumber(true)
      let lastblock = await store.getLatestBlock()
      const blockNum = normalizeBlockNumber(lastblock && lastblock.number)
      onBlockNumberChange(blockNum)
      updateBlockNumber(blockNum)
    } catch (err) {
      console.log("Some error has occured while fetching latest block id ", err)
    } finally {
      setfetchingBlockNumber(false)
    }
  }

  store.useRerenderIfChange(() => [store.getView()])
  var base = "display:inline-block;margin-right:10px;"
  var selected = `${base};cursor:default;font-weight:bolder;`
  var notselected = `${base};cursor:pointer;color:blue;`
  var isOneSide = store.getView() == "oneside"

  return (
    <div>
      <DuplicateThing>
        <ActionButtonsRow
          fetchingBlockNumber={fetchingBlockNumber}
          getLatestBlockNumber={getLatestBlockNumber}
          onBlockNumberChange={onBlockNumberChange}
          onIsMainnetChange={onIsMainnetChange}
          props={props}
          updateBlockNumber={updateBlockNumber}
          id={id}
        />
      </DuplicateThing>
      <div
        css={`
          background: #f0f0f2;
        `}
      >
        <div
          css={`
            display: flex;
            flex-direction: ${isOneSide ? "column" : "row"};
            padding: 10px;
          `}
        >
          {/* --------------left side step lists-------------- */}
          <div
            css={`
              border-right: 1px solid #ddd;
              width: ${isOneSide ? "100%" : "35%"};
              overflow: scroll;
              height: ${isOneSide ? "unset" : "90vh"};

              // always show scrollbars if it overflow
              ::-webkit-scrollbar {
                -webkit-appearance: none;
                width: 7px;
              }
              ::-webkit-scrollbar-thumb {
                border-radius: 4px;
                background-color: rgba(0, 0, 0, 0.5);
                box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
              }
            `}
          >
            <StepsList />
            <AddStepButtons />
            {store.selectedSimulationData["createdByName"] === "AI Agent" && (
              <>
                <div
                  css={`
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  `}
                >
                  <AIfeedback
                    type="simulation"
                    submissionText="Your solidity code and prompt will be shared with our technical team to enhance the product experience."
                    iconDimension={20}
                    showButton={true}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#888",
                    fontWeight: 'bold'
                  }}
                >
                  <span style={{color: 'red'}}>* </span>A.I. models can make mistakes. Please independently validate
                  that the output meets your expectations.
                </div>
              </>
            )}
          </div>
          {/* --------------right side step description-------------- */}
          <div
            css={`
              width: ${isOneSide ? "100%" : "65%"};
              overflow: scroll;
              height: ${isOneSide ? "unset" : "90vh"};

              // Always show scroll bars if it overflow
              ::-webkit-scrollbar {
                -webkit-appearance: none;
                width: 7px;
              }
              ::-webkit-scrollbar-thumb {
                border-radius: 4px;
                background-color: rgba(0, 0, 0, 0.5);
                box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
              }
            `}
          >
            <div
              css={`
                display: flex;
                flex-direction: column;
                overflow-x: auto;
                padding-left: 12px;
              `}
            >
              {store.getView() != "oneside" && (
                <div
                  css={`
                    flex-grow: 1;
                  `}
                >
                  <StepViewEdit />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function ActionButtonsRow({
  onIsMainnetChange,
  fetchingBlockNumber,
  onBlockNumberChange,
  updateBlockNumber,
  props,
  getLatestBlockNumber,
  id,
}) {
  var x = useRef(Math.random())
  return (
    <div
      css="display: flex;    
    justify-content: flex-end;
    align-items: center;
    margin-bottom:10px;"
    >
      <div
        css={`
          flex-grow: 1;
          margin-left: 10px;
        `}
      >
        <div
          css={`
            display: flex;
          `}
        >
          {store.getView() == "oneside" && (
            <>
              <div
                css="cursor: pointer;"
                onClick={(e) => store.colapseAll(true)}
              >
                <Tooltip tip="Collapse all">
                  <span>{VerticallyCollapseIcon()}</span>
                </Tooltip>
              </div>
              <div
                css="cursor: pointer; padding-left: 10px;"
                onClick={(e) => store.colapseAll(false)}
              >
                <Tooltip tip="Expand all">
                  <span>{VerticallyExpandIcon()}</span>
                </Tooltip>
              </div>
            </>
          )}
        </div>
      </div>

      <div css="margin-left: 10px;">
        <input
          checked={store.isMainnet}
          // @ts-ignore
          disabled={
            !props.isLoggedIn ||
            !store.userIsAllowed(props.isLoggedIn?.email) ||
            store.isReadOnly
          }
          onChange={(e) => {
            onIsMainnetChange(e.target.checked)
          }}
          type="checkbox"
          id="mainnet_fork"
        />
        <label htmlFor="mainnet_fork">Mainnet Fork</label>
      </div>
      {store.isMainnet &&
        window["config"]?.SKIP_SHOW_BLOCK_NUMBERS != "YES" && (
          <div css="margin-left: 10px;">
            <div
              css="display: flex;    
        justify-content: center;
        align-items: center;"
            >
              {fetchingBlockNumber ? (
                <div css="margin-left: 10px;">
                  <CircularProgress color="primary" />
                </div>
              ) : (
                <>
                  <div>
                    <b>Block #:</b>
                  </div>
                  <div css="margin-left: 5px;">
                    <div>
                      <InputNumber
                        id={"blockNumber"}
                        fullWidth={false}
                        size={"small"}
                        value={store.blockNumber}
                        disabled={
                          !props.isLoggedIn ||
                          !store.userIsAllowed(props.isLoggedIn?.email)
                        }
                        allowDecimal={false}
                        onChange={(value) => {
                          onBlockNumberChange(value)
                        }}
                        onBlur={(value) => {
                          updateBlockNumber(value)
                        }}
                        hasError={false}
                        errorText={""}
                      />
                    </div>
                  </div>
                  {props.isLoggedIn &&
                    store.userIsAllowed(props.isLoggedIn?.email) && (
                      <div
                        css="
                  margin-left: 5px;
                  color:#799fd4;
                  cursor: pointer;
                  text-decoration-line: underline;"
                        onClick={() => {
                          getLatestBlockNumber()
                        }}
                      >
                        Latest
                      </div>
                    )}
                </>
              )}
            </div>
          </div>
        )}

      <div css="margin-left: 10px;">
        <Button
          color="secondary"
          loading={store.isLoadingResults}
          disabled={
            !props.isLoggedIn ||
            store.isReadOnly ||
            store.isLoadingResults ||
            (store.isMainnet &&
              window["config"]?.SKIP_SHOW_BLOCK_NUMBERS != "YES" &&
              !store.blockNumber)
          }
          // showLoadingInsideButton
          loadingText={""}
          onClick={async () => {
            store.isLoadingResults = true
            store.updateStore()
            await delay(400)
            await store.saveStory()
            await delay(100)
            await store.simulatorTest()
            store.createLog({
              simulationId: id,
              operation: "Execute",
            })
          }}
          wrapped
          time={(store.steps?.length || 0) * 2000}
          startIcon={<PlayCircleOutlineIcon />}
          size="small"
        >
          Save & Play Simulation
        </Button>
      </div>
    </div>
  )
}

function DuplicateThing({ children }) {
  var [isDown, set_isDown] = useState(false)
  var ref = useRef(null)
  var ref2 = useRef(null)
  useEffect(() => {
    var int = setInterval(upd, 100)
    upd()
    window.addEventListener("scroll", upd)
    return () => {
      clearInterval(int)
      window.removeEventListener("scroll", upd)
    }
  })
  function upd() {
    if (isElementOutsideViewport(ref.current)) {
      set_isDown(true)
      if (ref2.current) {
        ref2.current.style.width = ref.current.getClientRects()[0].width + "px"
      }
    } else {
      set_isDown(false)
    }
  }

  return (
    <>
      <div
        css={`
          visibility: ${isDown ? "hidden" : "visible"};
        `}
        ref={ref}
      >
        <div ref={ref}>{children}</div>
      </div>
      {isDown && (
        <div
          css={`
            position: fixed;
            top: 0px;
            background: #f6f6fa;
            z-index: 1;
            border-bottom: 1px solid #b6b6ba;
          `}
          ref={ref2}
        >
          {children}
        </div>
      )}
    </>
  )
}

function isElementOutsideViewport(element) {
  try {
    var rect = element.getBoundingClientRect()
    var viewportWidth =
      window.innerWidth || document.documentElement.clientWidth
    var viewportHeight =
      window.innerHeight || document.documentElement.clientHeight

    return (
      rect.bottom < 0 ||
      rect.right < 0 ||
      rect.left > viewportWidth ||
      rect.top > viewportHeight
    )
  } catch (err) {}
}
